import { render } from "./NewAjuste.vue?vue&type=template&id=8317692a&scoped=true"
import script from "./NewAjuste.vue?vue&type=script&lang=js"
export * from "./NewAjuste.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./NewAjuste.vue?vue&type=style&index=1&id=8317692a&scoped=true&lang=css"
import "./NewAjuste.vue?vue&type=style&index=2&id=8317692a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8317692a"]])

export default __exports__